<template>
  <VSpinner v-if="!product" class="offset-top-16 offset-bottom-17" />
  <article v-else>
    <div id="STOCK_PRODUCT_CHANGE_CONFIRMATION" class="container-fixed">
      <!-- #53 -->
      <VProgress v-if="flags.progressBarEnabled" class="offset-top-2 offset-bottom-2" :steps="steps" active="substore.progress_confirmation" />

      <VSection large label="substore.order_completed" hl-style="padding-top: 9px">
        <p class="offset-top-1" v-html="product.texts.productChangeConfirmation"><!-- #95 --></p>
        <p v-html="product.texts.productChangeConfirmationBeforeButtons"><!-- #99 --></p>

        <!-- #100 -->
        <p>
          <span v-for="(b, index) in product.productDescription.buttons" :key="index" class="offset-right-1">
            <a v-if="b.resourcePath" :href="b.url" class="center" target="_blank"><img :src="`delegates/product/content/${b.resourcePath}`" :alt="b.alt"/></a>
            <a v-else :href="b.url" class="btn btn-brand center" target="_blank">{{ b.alt }}</a>
          </span>
        </p>

        <p v-html="product.texts.productChangeConfirmationAfterButtons"><!-- #101 --></p>
      </VSection>

      <!-- #102 -->
      <section class="offset-top-2 pull-right offset-right-1 button-bar">
        <router-link v-if="nextButtonType === PRODUCT_CATALOGUE" class="btn btn-default btn-brand" :to="{ name: PRODUCT_CATALOGUE }">
          {{ $t('substore.orderconfirmation_btn_next') }}
        </router-link>
        <router-link v-else-if="nextButtonType === STOCK" class="btn btn-default btn-brand" :to="{ name: STOCK }">
          {{ $t('common.navigation_STOCK') }}
        </router-link>
      </section>
    </div>

    <div class="container-fixed offset-top-6"> <VFootnotes :footnotes="footnotes" /><!-- #166 --> </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import Proxy from '@/proxies/SubstoreStockProxy';
import Transformer from '@/transformers/ProductChangeConfirmationTransformer';
import Footnotes from '@/utils/Footnotes';
import TitleMixin from '@/mixins/title';
import OrderStepsMixin from '@/mixins/orderSteps';
import VSpinner from '@/components/Spinner';
import VSection from '@/components/Section';
import emitter from '@/plugins/emitter';
import { PRODUCT_CATALOGUE, STOCK } from '@route-types';

export default {
  name: 'StockProductChangeConfirmation',

  components: {
    VSpinner,
    VSection,
    VProgress: () => import('@/components/Progress'),
    VFootnotes: () => import('@/components/UI/Footnotes'),
  },

  mixins: [TitleMixin, OrderStepsMixin],

  props: {
    newSubscriptionTemplateId: {
      type: String,
      required: true,
    },

    newUniqueSubscriptionId: {
      type: String,
      required: true,
    },

    confirmationInProgress: {
      type: String,
      required: false,
      default: null,
    },

    hideSelection: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      PRODUCT_CATALOGUE,
      STOCK,

      isOptin: false, // TODO!
      product: null,
      footnotes: null,
      flags: {
        progressBarEnabled: null,
        orderSelectionSkipped: null,
      },
    };
  },

  computed: {
    ...mapGetters('system', ['hasAccessCatalogue', 'hasAccessStockOverview']),

    nextButtonType() {
      if (this.hasAccessStockOverview) {
        return STOCK;
      }
      return null;
    },

    isConfirmationInProgress() {
      return !!this.confirmationInProgress;
    },
  },

  async created() {
    const response = await new Proxy({
      optin: this.isOptin,
      confirmationInProgress: this.isConfirmationInProgress,
    }).stockProductChangeConfirmation(this.newSubscriptionTemplateId, this.newUniqueSubscriptionId);

    if (response.head.fault !== null) throw new Error(response.head.fault);

    Object.keys(this.flags).forEach(key => {
      this.flags[key] = response.data[key];
    });

    this.footnotes = new Footnotes();
    this.product = Transformer.fetch(response.data.product, this.footnotes);
    emitter.emit('setBannerPicture', this.product.images.headerImageChangeConfirmationResourcePath);
    emitter.emit('setBannerHeadline', this.product.texts.headerTitleProductChangeConfirmation);
    emitter.emit('setBannerSubheadline', this.product.texts.headerSubTitleProductChangeConfirmation);

    this.$webtrekk.viewPageWithPayload('produktwechselbestaetigung', {
      page_type: 'basket',
      shop_product_sku: this.newSubscriptionTemplateId,
      shop_product_status: 'conf',
      shop_product_name: this.product.texts?.productName,
      shop_product_quantity: 1,
      shop_order_value: '0.0', // CAP-5294: stockProductChangeConfirmationResponse does not contain any price information
      shop_order_id: this.newUniqueSubscriptionId,
    });
  },
};
</script>

<style scoped>
.button-bar > span {
  position: relative;
  top: 1px;
  display: inline-block;
}
.center {
  position: relative;
  vertical-align: top;
}
</style>
